// extracted by mini-css-extract-plugin
export default {"dockedChatContainer":"DockedChatContainer_dockedChatContainer__tALgW","resizeHandle":"DockedChatContainer_resizeHandle__8OUmh"};